import React, { useState, useEffect, useRef } from 'react';

export function useActiveYuga() {
  const [yuga, setYuga] = useState("satya");
  const [chapter, setChapter] = useState("Prologue");
  useEffect(() => {
    const onScroll = () => {
      const sections = document.querySelectorAll("[data-yuga]");
      let best = null;
      let bestArea = 0;
      sections.forEach((s) => {
        const r = s.getBoundingClientRect();
        const visible = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
        if (visible > bestArea) { bestArea = visible; best = s; }
      });
      if (best) {
        const y = best.getAttribute("data-yuga");
        const c = best.getAttribute("data-chapter") || "Prologue";
        setYuga(y); setChapter(c);
        const map = {
          satya: { glow: "var(--satya-glow)", warm: "var(--satya-warm)", deep: "var(--satya-deep)", paper: "var(--satya-paper)", bg: "rgba(212,164,74,0.08)" },
          treta: { glow: "var(--treta-glow)", warm: "var(--treta-warm)", deep: "var(--treta-deep)", paper: "var(--treta-paper)", bg: "rgba(217,122,60,0.08)" },
          dvapara: { glow: "var(--dvapara-glow)", warm: "var(--dvapara-warm)", deep: "var(--dvapara-deep)", paper: "var(--dvapara-paper)", bg: "rgba(168,200,232,0.06)" },
          kali: { glow: "var(--kali-glow)", warm: "var(--kali-warm)", deep: "var(--kali-deep)", paper: "var(--kali-paper)", bg: "rgba(106,96,88,0.05)" },
        };
        const m = map[y] || map.satya;
        const rs = document.documentElement.style;
        rs.setProperty("--yuga-glow", m.glow);
        rs.setProperty("--yuga-warm", m.warm);
        rs.setProperty("--yuga-deep", m.deep);
        rs.setProperty("--yuga-paper", m.paper);
        rs.setProperty("--yuga-bg-glow", m.bg);
      }
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return { yuga, chapter };
}
